module.exports = __webpack_public_path__ + "img/people_speaking_chinese.f737d871.jpg";